import P5 from "p5";

import {  
    Mouse, 
    Quad, 
    Grid, 
    Ellipse, 
    Rectangle, 
    Text, 
    Copy, 
    Line, 
    Polygon ,
    Image,
    PixelObject,
    Frame
} from '../index.js'
class Root extends PixelObject {
    constructor(options, callback) {
        super(options)
        this.type = "ROOT"

        this.flat = []

        this.mouse = new Mouse()
        
        this.self = this
        this.callback = callback
        this.ctx = null
        this.eventTarget = new EventTarget();
        
        this.width = 512
        this.height = 512

        this.selectedNode = null
        this.lastSelectedNode = null

        this.fills = []

        // this.fills = [new Color({
        //     parent: this,
        //     type: 'solid',
        //     val: '#FFFFFF',
        //     color: {
        //         r: 255,
        //         g: 255,
        //         b: 255
        //     }
        // })]
    }

    init({canvasElement, callback, width, height}) {
        this.callback = callback
        this.width = width ? width : this.width
        this.height = height ? height : this.height
        new P5(this.script.bind(this), canvasElement);
    }

    convertCanvas(scale = 1) {
        this.ctx.noLoop()
        const self = this

        // Scale canvas
        if (scale != 1) {
            this.ctx.resizeCanvas(this.width * scale, this.height * scale)
            this.children[0].width = this.width * scale
            this.children[0].height = this.height * scale
            this.children[0].buffer.resizeCanvas(this.width * scale, this.height * scale)
            this.children[0].renderBuffer()
            this.ctx.draw()
        }

        return new Promise((accept) => {
            let canvas = document.getElementById('defaultCanvas0');
            canvas.toBlob(async(blob)=>{
                const arrayBuffer = await blob.arrayBuffer()
                const uint8Array = new Uint8Array(arrayBuffer);

                // Revert scaling
                if (scale != 1) {
                    self.ctx.resizeCanvas(self.width, self.height)
                    self.children[0].width = self.width
                    self.children[0].height = self.height
                    self.children[0].buffer.resizeCanvas(self.width, self.height)
                    self.children[0].renderBuffer()
                }

                self.ctx.loop()
                return accept(uint8Array)
            }, 'image/png', 1);
        })
    }

    export() {
        this.ctx.save('PixelExport.png')
    }
    
    mounted() {
        if (this.callback) {
            this.callback()
        }
    }

    on(event, callback) {
        this.eventTarget.addEventListener(event, (event) => callback(event.detail))
    }

    dispatch(event, detail) {
        this.eventTarget.dispatchEvent(new CustomEvent(event, { detail }))
    }

    setSelected(node) {
        if (this.lastSelectedNode) {
            this.lastSelectedNode.selected = false
        }
        node.selected = true
        this.lastSelectedNode = node
        this.dispatch('selectedNodeChanged', node)
    }

    getSelectedNode() {
        return this.lastSelectedNode;
    }

    add({type, parent, props}) {
        const classMapping = {
            'Quad': Quad,
            'Rectangle': Rectangle,
            'Ellipse' : Ellipse,
            'Grid': Grid,
            'Image': Image,
            'Text': Text,
            'Polygon': Polygon,
            'Copy': Copy,
            'Line': Line,
            'Frame': Frame
          };

        const object = new classMapping[type]({ ctx: this.ctx, ...props })
        object.listenChanges()
        object.root = this
        if (parent) {
            this.addChild({object, parent, props})
        } else {
            this.addChild({object, props})
        }
       
        this.flat.push(object)
        this.setSelected(object)
        return object
    }

    addChild({object, parent, props}) {
        if (parent) {
            object.setParent(parent)
            parent.children.push(object)
        } else {
            object.setParent(this)
            this.children.push(object)
        }
        this.dispatch('dataChanged', {data: this.children})
    }

    deleteNode(node) {
        if (this.lastSelectedNode && this.lastSelectedNode.id == node.id) {
            this.lastSelectedNode = null
            this.dispatch("selectedNodeChanged")
        } 
        node.delete()
    }

    fillBackground() {
        this.ctx.clear()
        if (this.fills && this.fills.length > 0) {
            const fills = this.getActiveFills()
            if (fills.length > 0) {
                let rgb = fills[0].color
                this.ctx.background(rgb.r, rgb.g, rgb.b, this.opacity / 100 * fills[0].opacity)
            } 
        }
    }

    script(p5) {
        p5.setup = () => {
            p5.createCanvas(this.width, this.height);
            p5.background(255, 255, 255);
            p5.rectMode(p5.CENTER);
            p5.colorMode(p5.RGB, 255, 255, 255, 100);
            this.ctx = p5
            this.mounted()
        };

        p5.draw = () => {
            this.fillBackground()
            this.dispatch('drawFrame')
            this.mouse.updatePosition()
            this.children.slice().reverse().forEach(child => child.draw())
        };
    }
}

export default Root
